import { createFileRoute } from "@tanstack/react-router";
import { AgendaShell } from "@/components/agenda/agenda-shell";
import { AgendaEstoque } from "@/components/agenda/agenda-estoque";

export const Route = createFileRoute("/agenda/estoque")({
  component: () => (
    <AgendaShell>
      <AgendaEstoque />
    </AgendaShell>
  ),
  head: () => ({ meta: [{ title: "Estoque — Agenda — GPS Drive" }] }),
});
